import { render, staticRenderFns } from "./AddAndEdit.vue?vue&type=template&id=0224fbdc&scoped=true"
import script from "./AddAndEdit.vue?vue&type=script&lang=js"
export * from "./AddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./AddAndEdit.vue?vue&type=style&index=0&id=0224fbdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224fbdc",
  null
  
)

export default component.exports